// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"242":"ec6e2638","532":"9c8da26a","971":"7127f916","995":"24ec2304"}[chunkId] + ".chunk.js";
};